// extracted by mini-css-extract-plugin
export default {"header":"Layout_header__3l99Q"};